// 
export default {
  WORK_LIST: '/jury/work/manage/workList',                    // 作业列表
  
  MANAGE_DETAIL: '/jury/work/manage/details',                 // 作业详情

  REVIEW_RECORDS: '/jury/work/manage/reviewRecords',          // 审核记录

  MANAGE_REVIEW: '/jury/work/manage/review',                    // 审核作业

  TASK_LIST: '/jury/work/manage/taskList',                      // 任务列表

  MODULE_DETAIL: '/jury/moudle/detail',                        // 模板详情查询

  CALCULATE_SCORE: '/jury/moudle/calculate/score',               // 评分模板总分计算
  
  GET_FILE_WITH_PDF_WATERMARK: '/jury/work/manage/getFileWithPDFWatermark'   // PDF文件添加水印
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/operation.js